export default {
  ENTER: "enter",
  RESEND_OTP: "Resend OTP",
  OTP_LOGIN: "Login using OTP",
  CONFIRM_PASSWORD: "confirm password",
  EMAILADDRESS: "email address",
  PASSWORD: "password",
  KEEPMELOGGEDIN: "keep me logged in",
  LOGIN: "login/signup",
  PHONENUMBER: "phone number",
  OTP: "otp",
  USERNAME: "username",
  FORGOTPASSWORD: "forgot password",
  SIGNUP: "sign up",
  OURSTORY: "our story",
  OUR_HISTORY: "our history",
  OUR_HISTORY_DESC:
    "The history of Sindhi Dry Fruits dates back to the late 1930s, even prior to the independent India. It was then that the founder Shri. Gagan Mal Kataria began trading in Dry Fruits in Sindh, now in Pakistan. As independent India was carved out, Shri. Gagan Mal Kataria took a path breaking decision – establishing a retail shop – that formed the foundation of our business today. His gumptious efforts were dedicated to preparing and cleaning every item possible by himself: from making mouth-watering Tilbhuggas to frying and roasting cashew nuts. Years passed realising his efforts and it was time for his two sons – Mr. Ashok Kumar Kataria and Mr. Inder Kumar Kataria – to enter the prestigious business. Beyond measure, they too dedicated their cent per cent to the business and are continuing to do so.",
  OURSTORY_DESC:
    "Sindhi Dry Fruits is An ISO 22000:2005, HACCP certified food and packaging firm. Situated in the heart of Central Market, Lajpat Nagar-II, New Delhi, the firm is committed to serving its customers with quality dry fruits at affordable prices. It has revolutionised the way celebrations are made while keeping in view the health of its valuable customers. The firm’s efforts are directed towards providing its esteemed customers with natural products of unmatchable quality. In 2017, the brand came up with a boutique outlet at K 14 Lajpat Nagar 2 for those customers who value convenience more. A hybrid store packing all the features of the age-old store and a fresh experience to shop for a healthy living. All this with a jumbo bonus: Exactly same prices!",
  IMAGE_GALLERY: "image gallery",
  ORDER_SELECTION: "our collection",
  DELIVERY_DETAILS: "delivery details",
  LOGOUT: "logout",
  SUBMIT: "submit",
  CONFIRM_ORDER: "confirm order",
  SHOP_MORE_ITEMS: "shop more items",
  APPLY_COUPON: "apply coupon",
  SELECT_DELIVERY: "select delivery",
  VALID_COUPON: "Orders will be confirmed in cash",
  INVALID_COUPON: "Invalid Coupon",
  BACK_TO_HOMEPAGE: "back to homepage",
  INTER_STATE_DELIVERY: "Inter-State Delivery",
  INTER_STATE_DELIVERY_CONTENT:
    "Sindhi Dry Fruits®️ now introduces inter-state delivery for you to order from the comfort of your home. Our outsourced courier partners now deliver across the country. Extremely convenient, low-cost and efficient method to ensure you never run out of essential items to maintain a healthy lifestyle.",
  SAME_DAY_DELIVERY: "Same Day Delivery",
  SAME_DAY_DELIVERY_CONTENT:
    "Sindhi Dry Fruits®️ now introduces same-day delivery for you to order from the comfort of your home. Our outsourced delivery partners now deliver across Delhi-NCR. Extremely convenient, low-cost and efficient method to ensure you never run out of essential items to maintain a healthy lifestyle.",
  CONFIRM_ORDER_DECLARATION:
    "I understand that I will not be able to edit my order after submission.",
  ORDER_PLACED_SUCCESSFULLY:
    "Thank you for shopping with us. Your order has been placed successfully.",
  ORDER_PLACED_UNSUCCESSFULLY:
    "Order was not placed successfully. Please try again.",
  CONFIRM_STORE_PICKUP_DECLARATION:
    "For store pickups, we charge a total of 10% of the total amount as pre payment and the rest has to the given at the time of pickup. Press Okay to confirm and Home Delivery to otp out from store pickup",
};
